import React from 'react'
import {
  FormLabel,
  FormDashboardInput as FormInput,
  InputPrefix,
  FormDashboardTextarea,
  FormRow,
} from '../../../components'
import { FormSystem } from './form-system'
import { SystemProvider } from '../../../features/system/provider'
import { formUpdater } from '../../../utils'
import debounce from 'lodash.debounce'
import { useSelector } from 'react-redux'
import khub from '../../../database/khub.json'

const namePlaceholder = {
  en: 'Enter Organization Name',
  id: 'Masukkan Nama Organisasi Anda'
}

const FormBasic = ({ onChange }) => {
  const [form, setForm] = React.useState({})
  const translation = useSelector(state => state.translation.data)
  const language = useSelector(state => state.system.language)

  const updateForm = debounce((e) => formUpdater(e, form, setForm), 250)

  React.useEffect(() => {
    if(typeof onChange === 'function'){
      onChange(form)
    }
    //eslint-disable-next-line
  }, [form])

  const handleMulti = (e, key) => {
    console.log(e, key)

    updateForm({
      target: {
        name: key,
        value: e
      }
    })
  }

  return (
    <>
      <h2 className="text-lg mb-5 lg:mb-8 font-primary font-bold">
        {translation.ORGANIZATION.basic_information[language.name]}
      </h2>

      <FormRow>
        <FormLabel>
          {translation.ORGANIZATION.url[language.name]}
        </FormLabel>
        <InputPrefix
          name="organization_url"
          prefix={`${khub.url}/`}
          onChange={(e) => {e.persist(); updateForm(e)}}
          required
          prefixStyle={{
            minWidth: '107px'
          }}
          placeholder="username"
        />
      </FormRow>

      <FormRow>
        <FormLabel>
          {translation.ORGANIZATION.name[language.name]}
        </FormLabel>
        <FormInput
          name="organization_name"
          placeholder={namePlaceholder[language.name]}
          className="w-full"
          onChange={(e) => {e.persist(); updateForm(e)}}
          required
        />
      </FormRow>

      <SystemProvider>
        <FormSystem handleMulti={handleMulti} />
      </SystemProvider>

      <FormRow>
        <FormLabel>
          {translation.ORGANIZATION.mission_statement[language.name]}
        </FormLabel>
        <FormDashboardTextarea
          className="w-full"
          rows={5}
          placeholder={translation.ORGANIZATION.mission_statement_placeholder[language.name]}
          name="mission_statement"
          onChange={(e) => {e.persist(); updateForm(e)}}
          required
        />
      </FormRow>
    </>
  )
}

export { FormBasic }
